<template>
    <DropMenu
        :menu-state.sync="isMenuOpen"
        :value="Array.isArray(selected) ? selected : []"
        :items="items"
        :menu-props="menuProps"
        nudge-bottom="outlined ? '62px' : denseTop ? '33px' : '46px'"
        :multi="multi"
        :deselect="deselect"
        :name-key="nameKey"
        :value-key="valueKey"
        :auto-focus="readonly"
        avatars
        :show-selected-first="showSelectedFirst"
        :searchable="searchable"
        :search-value="searchValue"
        :custom-rules="customRules"
        :sort="sort"
        :sort-field="sortField"
        :sort-asc="sortAsc"
        @input="onInput"
    >
        <template #tile-content="{ item }">
            <slot
                name="item.name"
                :item="item"
            />
        </template>
        <template v-slot:actions>
            <slot name="actions"/>
        </template>
        <template v-slot="{ on }">
            <v-text-field
                :class="(denseTop ? 'pt-0 mt-0' : '') + ' ' + textClass"
                :value="comboboxSelected"
                :outlined="outlined"
                :error-messages="errorMessages"
                :hide-details="hideDetails !== null ? hideDetails : !errorMessages"
                :dense="dense"
                :solo="solo"
                :label="label"
                :placeholder="placeholder"
                :disabled="disabled"
                :readonly="readonly"
                :append-icon="disabled ? '' : isMenuOpen ? '$ChevronUp' : '$ChevronDown'"
                v-on="on"
                @input="$emit('textInput', $event);"
                @keypress="$emit('keypress', $event)"
                @click:append="on.click"
            />
        </template>
    </DropMenu>
</template>

<script>
import {ref, computed} from "@vue/composition-api";
import DropMenu from "./NewFilterBar/components/DropMenu";

export default {
    name: "ComboboxDropdown",
    components: {
        DropMenu
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        selected: {
            type: [Array, String, Number],
            default: () => []
        },
        sort: {
            type: Boolean,
            default: true
        },
        sortField: {
            type: String,
            default: ''
        },
        sortAsc: {
            type: Boolean,
            default: true
        },
        nameKey: {
            type: String,
            default: ""
        },
        deselect: {
            type: Boolean,
            default: true
        },
        valueKey: {
            type: String,
            default: ""
        },
        label: {
            type: String,
            default: ""
        },
        dense: {
            type: Boolean,
            default: false
        },
        solo: {
            type: Boolean,
            default: false
        },
        errorMessages: {
            type: [Array, String],
            default: () => null
        },
        hideDetails: {
            type: Boolean,
            default: null
        },
        customRules: {
            type: Function,
            default: null
        },
        multi: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: true
        },
        readonly: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: ""
        },
        searchable: {
            type: Boolean,
            default: true
        },
        searchValue: {
            type: String,
            default: ''
        },
        itemText: {
            type: Function,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        denseTop: {
            type: Boolean,
            default: false
        },
        textClass: {
            type: String,
            default: ''
        },
        inputText: {
            type: [String, Number],
            default: null
        },
        menuProps: {
            type: Object,
            default: () => ({
                'open-on-hover': false,
                'offset-y': true
            })
        },
        showSelectedFirst: {
            type: Boolean,
            default: true
        }
    },
    setup(props, ctx) {
        const isMenuOpen = ref(false);

        const onInput = (e) => {
            if (props.multi) {
                ctx.emit("input", e);
            } else if (Array.isArray(e) && e.length) {
                ctx.emit("input", e[0]);
            } else {
                ctx.emit("input", e);
            }
        }

        const comboboxSelected = computed(() => {
            if (props.inputText !== null) {
                return props.inputText;
            }

            let res = []
            if (Array.isArray(props.selected)) {
                for (let selectedItem of props.selected) {
                    let item = null
                    if (typeof selectedItem === "string") {
                        let foundItem = props.items.find(x => selectedItem === x[props.valueKey])
                        if (foundItem) {
                            item = foundItem[props.nameKey]
                        } else if (!props.readonly) {
                            item = selectedItem
                        }

                    } else {
                        item = props.items.find(x => selectedItem[props.valueKey] === x[props.valueKey])[props.nameKey]
                    }

                    if (item) {
                        res.push(item)
                    }
                }
            } else {
                res = props.selected;
            }

            return res;
        })

        return {
            isMenuOpen,
            onInput,
            comboboxSelected
        }
    }
}
</script>

<style scoped lang="scss">
.v-input ::v-deep input {
    font-size: 14px !important;
}
</style>
